export const useStudentClassroomsDataStore = () => {
  const uid = useCurrentUID();

  if (!uid) {
    // throw new Error('No UID found')s
    navigateTo("/auth/login");
    return useStudentsClassroomsData("")();
  }

  return useStudentsClassroomsData(uid)();
};
